/* Einmalige Aktion "Logos ins Register kopieren" (Weg B, Entscheidung Bastian N7) — reine Ablauflogik.
 *
 * Schritt 2 der Migration übernimmt nur den PFAD der vorhandenen Logo-Datei (avatars/club-<spielerId>/…) ins
 * Register. Diese Aktion kopiert die Datei je Verein nach avatars/clubs/<vereinsId>/<Dateiname> und setzt
 * danach logo_path auf die Kopie. Danach gehört das Logo dem Register, nicht mehr einem Spieler.
 *
 * KOPIE, nie Verschieben: Die Altdatei bleibt liegen, io bietet absichtlich keine Löschfunktion. Der Ablauf
 * ist wiederholbar: Vereine, deren Logo schon im Registerordner liegt, werden übersprungen; ist nach einem
 * Abbruch die Datei kopiert, aber der Pfad noch nicht gesetzt, kopiert der nächste Lauf erneut (das Ziel
 * existiert dann schon, das zählt als Erfolg) und setzt den Pfad. Ein Fehler bei einem Verein bricht den Lauf
 * nicht ab.
 */

import { logoIsInRegister, registerLogoTarget } from './footballClub.js';

/** Vereine, deren Logo noch nicht im Registerordner liegt. */
export function clubsNeedingCopy(clubs) {
  return (clubs || []).filter((c) => c.logoPath && !logoIsInRegister(c));
}

/**
 * io = {
 *   copy(from, to) -> Promise      (Datei kopieren; wirft bei Fehler; ein schon vorhandenes Ziel ist Erfolg)
 *   setLogo(clubId, path) -> Promise (logo_path setzen; wirft bei Fehler)
 * }
 * onProgress({ total, done, failed, current }) nach jedem Verein; shouldStop() bricht sauber ab.
 * @returns {Promise<{ total: number, copied: number, failed: string[], stopped: boolean }>}
 */
export async function copyLogosToRegister({ clubs, io, onProgress = () => {}, shouldStop = () => false }) {
  const todo = clubsNeedingCopy(clubs);
  const failed = [];
  let copied = 0;
  let stopped = false;
  onProgress({ total: todo.length, done: 0, failed: 0, current: null });
  for (const club of todo) {
    if (shouldStop()) { stopped = true; break; }
    const target = registerLogoTarget(club.id, club.logoPath);
    try {
      await io.copy(club.logoPath, target);
      await io.setLogo(club.id, target);
      copied++;
    } catch (e) {
      console.error('[clubLogoCopy] Verein übersprungen:', club.id, e && e.message);
      failed.push(club.id);
    }
    onProgress({ total: todo.length, done: copied + failed.length, failed: failed.length, current: club.id });
  }
  return { total: todo.length, copied, failed, stopped };
}
